import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "page page-new-works" }
const _hoisted_2 = ["src"]

import { computed, reactive, ref, watch } from 'vue'
import SwiperItem from '@/components/new-works/SwiperItem.vue'
import CategoryItem from '@/components/new-works/CategoryItem.vue'
import SwiperInSwiper from '@/components/new-works/SwiperInSwiper.vue'
import SerialProduct from '@/components/new-works/SerialProduct.vue'
import { FORMATTED_PRODUCT_SERIE } from '@/data/series'
import useSelect from '@/hooks/use-select'
import { ProductCategoryConfig } from '@/data/const'
import { namedImages, useConfAndQueryStore, useLayoutStore } from '@/store'
import { NewWorksItemWithCondition, StackingSet } from '@/data/newworks'
import { delay, throttle } from '@/utils'
import useNewWorks from '@/hooks/use-new-works'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'NewWorks',
  props: { ready: Boolean },
  setup(__props) {

const props = __props

const { selectCategoryAndAttr, selectStackingSet } = useSelect()

const { gotoAllWorks, showManualLoading } = useLayoutStore()
const confAndQueryStore = useConfAndQueryStore()

const scroller = ref<HTMLDivElement>()
const autoChangeStatesTimer = ref<number>()

const isTouchedScroller = ref(false)
const isAutoFixingSwipier = ref(false)

const slidesState = ref<'normal' | 'guiding'>('normal')
const slideState = ref<'snap' | 'free'>('snap')
const guidingState = ref<
  'initial' | 'enter' | 'entered' | 'guiding' | 'leave' | 'left'
>('initial')

const touchState = reactive({
  started: false,
  startY: 0,
  moved: false,
  deltaY: 0
})

const isMaskVisibile = computed(
  () => isAutoFixingSwipier.value || guidingState.value === 'enter'
)

const {
  isSimulated,
  scrollFunc,
  selectSeriesIfIsH6951,
  selectCategoryWithSource,
  selectSeriesWithSource
} = useNewWorks()

const scrollToIndex = (scrollFunc.value = async (
  index: number,
  smooth = true
) => {
  if (scroller.value) {
    isAutoFixingSwipier.value = smooth
    scroller.value?.scrollTo({
      top: scroller.value.getBoundingClientRect().height * index,
      behavior: smooth ? 'smooth' : 'instant'
    })
    await delay(300)
    isAutoFixingSwipier.value = false
  }
})

const onSwiperItemClick = throttle(
  async (item: StackingSet | NewWorksItemWithCondition) => {
    confAndQueryStore.report(item.actionNumber)
    if (item.type === 'stackings') {
      selectStackingSet(item as StackingSet)
    } else {
      const [isH6951, selected] = selectSeriesIfIsH6951(item)
      if (isH6951) {
        if (selected) {
          await showManualLoading()
        }
      } else if (selectCategoryAndAttr(item)) {
        await showManualLoading()
      }
    }
    gotoAllWorks(true, true)
  }
)

const onCategoryItemClick = throttle(
  async (category: ProductCategoryConfig) => {
    confAndQueryStore.report(category.actionNumber)
    if (selectCategoryWithSource(category)) {
      await showManualLoading()
    }
    gotoAllWorks(true, true)
  }
)

const onSerialProductItemClick = throttle(
  async (data: FORMATTED_PRODUCT_SERIE) => {
    confAndQueryStore.report(data.actionNumber)
    if (selectSeriesWithSource(data)) {
      await showManualLoading()
    }
    gotoAllWorks(true, true)
  }
)

const fixIndex = async () => {
  if (touchState.moved) {
    const nextIndex =
      confAndQueryStore.firstClass.displayIndex +
      (touchState.deltaY > 0 ? -1 : 1)
    if (nextIndex < 0 || nextIndex > confAndQueryStore.slides.length - 1) return
    await delay(50)
    scrollToIndex(confAndQueryStore.firstClass.displayIndex, false)
    await delay(100)
    scrollToIndex(nextIndex, true)
  }
}

const resetSlidesStates = async () => {
  slidesState.value = 'normal'
  await delay(700)
  slideState.value = 'snap'
}
const resetGuidingState = async (fromScroller: boolean) => {
  // console.log('[[ Guiding ] 重置指引 ]', {
  //   fromScroller,
  //   state: guidingState.value
  // })
  switch (guidingState.value) {
    case 'initial':
    case 'left':
      // console.log('[[ Guiding ] 引导尚未开始或已结束 ]')
      break

    case 'enter':
      if (fromScroller) {
        console.error('[[ Guiding ] 指引入场中 ]')
        break
      } else {
        // console.log('[[ Guiding ] 指引入场中 ]')
      }
    // eslint-disable-next-line no-fallthrough
    case 'entered':
    case 'guiding':
      // console.log('[[ Guiding ] 指引离场 ]')
      guidingState.value = 'leave'
      await delay(300)
      // console.log('[[ Guiding ] 指引复位 ]')
      guidingState.value = 'left'
      break

    case 'leave':
      // console.log('[[ Guiding ] 指引离场中 ]')
      await delay(300)
      // console.log('[[ Guiding ] 指引复位 ]')
      guidingState.value = 'left'
      break
  }
}

const onTouchMaskStart = async (e: TouchEvent) => {
  touchState.started = true
  touchState.startY = e.touches[0].clientY
  if (autoChangeStatesTimer.value) clearTimeout(autoChangeStatesTimer.value)
}

const onTouchMaskMove = async (e: TouchEvent) => {
  if (!touchState.started) return
  if (touchState.moved) return
  touchState.moved = true
  touchState.deltaY = e.touches[0].clientY - touchState.startY
}

const onTouchMaskEnd = async () => {
  resetSlidesStates()
  resetGuidingState(false)
  fixIndex()
}

const onTouchScroller = async () => {
  if (isSimulated.value && !isTouchedScroller.value) {
    isTouchedScroller.value = true

    if (autoChangeStatesTimer.value) clearTimeout(autoChangeStatesTimer.value)
    resetSlidesStates()
    resetGuidingState(true)
  }
}

const startGuiding = () => {
  clearTimeout(autoChangeStatesTimer.value)
  if (
    isTouchedScroller.value === false &&
    guidingState.value === 'initial' &&
    confAndQueryStore.firstClass.displayIndex <
      confAndQueryStore.slides.length - 1
  ) {
    slideState.value = 'free'
    slidesState.value = 'guiding'

    autoChangeStatesTimer.value = setTimeout(() => {
      guidingState.value = 'enter'
      autoChangeStatesTimer.value = setTimeout(async () => {
        autoChangeStatesTimer.value = setTimeout(async () => {
          resetSlidesStates()
          guidingState.value = 'guiding'
        }, 500)
        guidingState.value = 'entered'
      }, 600)
    }, 300)
  }
}

watch([isSimulated, () => props.ready], async ([simed, ready]) => {
  if (simed && ready && confAndQueryStore.firstClass.isBanner) {
    await delay(1500)
    startGuiding()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "page-new-works__scroll",
      ref_key: "scroller",
      ref: scroller,
      onTouchstart: onTouchScroller
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(['page-new-works__slides', slidesState.value, slideState.value])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(confAndQueryStore).slides, (slide, slideIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `swiper-${slideIndex}`,
            class: _normalizeClass({
            'swiper-item': true,
            'swiper-in-swiper-item':
              slide.type === 'series' || slide.type === 'categories'
          })
          }, [
            (slide.type === 'series')
              ? (_openBlock(), _createBlock(SwiperInSwiper, {
                  key: 0,
                  title: "腕表",
                  "data-source": slide.series,
                  "init-index": 
              _unref(confAndQueryStore).firstClass.key === slide.key
                ? _unref(confAndQueryStore).secondClass.index
                : 1
            ,
                  onTouchscroller: onTouchScroller
                }, {
                  default: _withCtx(({ data }: { data: FORMATTED_PRODUCT_SERIE }) => [
                    _createVNode(SerialProduct, {
                      kv: data.icon,
                      title: data.title,
                      onTap: ($event: any) => (_unref(onSerialProductItemClick)(data))
                    }, null, 8, ["kv", "title", "onTap"])
                  ]),
                  _: 2
                }, 1032, ["data-source", "init-index"]))
              : (slide.type === 'categories')
                ? (_openBlock(), _createBlock(SwiperInSwiper, {
                    key: 1,
                    title: "精选作品",
                    "data-source": slide.categories,
                    "init-index": 
              _unref(confAndQueryStore).firstClass.key === slide.key
                ? _unref(confAndQueryStore).secondClass.index
                : 1
            ,
                    onTouchscroller: onTouchScroller
                  }, {
                    default: _withCtx(({ data }: { data: ProductCategoryConfig }) => [
                      _createVNode(CategoryItem, {
                        cover: data.kv,
                        category: data.label,
                        onTap: ($event: any) => (_unref(onCategoryItemClick)(data))
                      }, null, 8, ["cover", "category", "onTap"])
                    ]),
                    _: 2
                  }, 1032, ["data-source", "init-index"]))
                : (_openBlock(), _createBlock(SwiperItem, {
                    key: 2,
                    type: slide.type,
                    cover: slide.kv,
                    category: slide.query.categories[0]?.label,
                    title: slide.title as string[],
                    subtitle: (slide as StackingSet).subtitle || '',
                    onTap: ($event: any) => (_unref(onSwiperItemClick)(slide))
                  }, null, 8, ["type", "cover", "category", "title", "subtitle", "onTap"]))
          ], 2))
        }), 128))
      ], 2)
    ], 544),
    _createElementVNode("div", {
      class: _normalizeClass(['page-new-works__guide', guidingState.value])
    }, [
      _createElementVNode("img", {
        class: "page-new-works__guide-icon",
        src: _unref(namedImages).icon_arrow_downward
      }, null, 8, _hoisted_2)
    ], 2),
    (isMaskVisibile.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "page-new-works__mask",
          onTouchstart: onTouchMaskStart,
          onTouchmove: onTouchMaskMove,
          onTouchend: onTouchMaskEnd,
          onTouchcancel: onTouchMaskEnd
        }, null, 32))
      : _createCommentVNode("", true)
  ]))
}
}

})